// removed by extract-text-webpack-plugin
module.exports = {"container":"_3jIUkCJPSGoODzo849VzPI","signature":"_2T1rZv7HdA0IbErjwWY_jU","menuLink":"_1j-H0MPcR58E0Y-L6lNjAj"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Layout/Navbar/User/Signature/styles.css
// module id = 1312
// module chunks = 0